module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/TrustAndTransparency_CargoSmart_bg.e8136275.jpg";